import styled from "styled-components";

const CheckboxWrapper = styled.div`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${(props) => props["checkboxColor"]};
    border-color: ${(props) => props["checkboxColor"]};
  }
`;

export default CheckboxWrapper;
